import * as React from 'react'

function SvgDirectMint(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 44 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.2} cx={10} cy={17.654} r={10} fill="#00D37E" />
      <path
        opacity={0.6}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.423 16.116a.577.577 0 00.267-1.089L9.267 12.72a.577.577 0 00-.534 0L4.31 15.027a.577.577 0 00.267 1.089h8.846zm-4.476.909c.319 0 .577.258.577.577v2.29a.577.577 0 11-1.154 0v-2.29c0-.319.259-.577.577-.577zM14 21.693a.577.577 0 01-.577.577H4.577a.577.577 0 110-1.154h8.846c.319 0 .577.258.577.577zm-7.208-4.091a.577.577 0 00-1.154 0v2.29a.577.577 0 101.154 0v-2.29zm4.887-.577c.319 0 .577.258.577.577v2.29a.577.577 0 11-1.154 0v-2.29c0-.319.259-.577.577-.577z"
        fill="#00D37E"
      />
      <g filter="url(#direct-mint_svg__filter0_d_1020:39297)">
        <circle cx={26} cy={17.654} r={10} fill="#fff" />
      </g>
      <path
        d="M26.74 16.279h-1.48c-.654 0-1.186-.448-1.186-1 0-.55.532-1 1.185-1h2.963c.573 0 1.037-.391 1.037-.875 0-.483-.464-.875-1.037-.875h-1.185v-1c0-.483-.464-.875-1.037-.875s-1.037.392-1.037.876v1.011C23.304 12.668 22 13.847 22 15.28c0 1.517 1.462 2.75 3.26 2.75h1.48c.654 0 1.186.449 1.186 1 0 .552-.532 1-1.185 1h-2.963c-.573 0-1.037.392-1.037.875s.464.875 1.037.875h1.185v1c0 .483.464.875 1.037.875s1.037-.392 1.037-.875v-1.012C28.696 21.641 30 20.461 30 19.03c0-1.516-1.462-2.75-3.26-2.75z"
        fill="#00D37E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 10.95c-.436 0-.726.29-.726.58v1.284l-.286.022c-1.53.117-2.676 1.194-2.676 2.443 0 1.322 1.287 2.455 2.947 2.455h1.482c.79 0 1.496.55 1.496 1.295 0 .746-.706 1.295-1.496 1.295h-2.963c-.436 0-.726.291-.726.58s.29.58.726.58h1.496v1.295c0 .289.29.58.726.58s.725-.291.725-.58v-1.284l.287-.022c1.53-.117 2.676-1.195 2.676-2.444 0-1.322-1.287-2.454-2.947-2.454h-1.482c-.79 0-1.496-.55-1.496-1.296 0-.745.706-1.295 1.496-1.295h2.963c.436 0 .726-.29.726-.58 0-.288-.29-.58-.726-.58h-1.497V11.53c0-.29-.29-.58-.725-.58z"
        fill="#00D37E"
      />
      <path
        d="M12 5.879a7 7 0 019.9 0l-1.4-3.95M23.175 29.604a7 7 0 01-9.9 0l1.4 3.95"
        stroke="#4FE1A6"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="direct-mint_svg__filter0_d_1020:39297"
          x={8}
          y={1.654}
          width={36}
          height={36}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.662745 0 0 0 0 0.396078 0 0 0 0.2 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1020:39297"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1020:39297"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgDirectMint
